import React, { Suspense, lazy } from 'react';
import { observer } from 'mobx-react';
import { Loading } from 'components';
import 'codemirror/lib/codemirror.css';
import './codemirror.css';
import './wikifactory.css';

const CodeMirror = lazy(() => import('libs/rendering/text/codemirror'));

@observer
export class TextViewer extends React.Component {
  render() {
    // NOTE: codemirror's 'viewportMargin' should be set to infinity if we want
    // the browser's 'find' function to work but will cause performance degradation
    return (
      <Suspense fallback={<Loading />}>
        <CodeMirror {...this.props} />
      </Suspense>
    );
  }
}
